import { Stack, Typography } from '@mui/material';
import { formatFileSize } from './utils';

export interface AIFileNameInfoProps {
  fileName?: string;
  fileSize?: number;
  uploadedBy?: string;
}

export const AIFileNameInfo = ({
  fileName,
  fileSize,
  uploadedBy,
}: AIFileNameInfoProps) => {
  const formattedFileSize = formatFileSize(fileSize);

  return (
    <Stack mt={0.625}>
      <Typography sx={{ wordBreak: 'break-word', fontWeight: '600' }}>
        {fileName}
      </Typography>
      <Typography variant="body2" sx={{ color: '#919eab' }}>
        {uploadedBy} • {formattedFileSize}
      </Typography>
    </Stack>
  );
};
